<template>
  <form id="form" @submit.prevent="onSubmit">

    <div id="btn-acoes-t">
      <v-btn width="90px" type="button" small :disabled="acao != ''" color="cyan white" class="rounded-sm"  @click="novo">Novo</v-btn>
      <v-btn width="90px" type="button" small :disabled="acao != '' || !this.id" color="cyan" class="teste rounded-sm" @click="editar">Editar</v-btn>
      <v-btn width="90px" type="button" :loading="acao == 'excluir'" small :disabled="acao != '' || !this.id" color="error" class="rounded-sm" @click="excluir">Excluir</v-btn>
    </div>

    <slot></slot>


    <div id="btn-acoes-b">
      <v-btn width="90px" type="submit" :loading="loading" small :disabled="acao == '' || acao == 'excluir' || loading" color="teal" class="teste rounded-sm">Salvar</v-btn>
      <!-- <v-btn type="submit" :loading="loading" small :disabled="loading" color="teal" class="teste">Salvar</v-btn> -->
      <v-btn width="90px" type="button" small :disabled="acao == '' || acao == 'excluir' || loading" color="" class="rounded-sm"  @click="cancelar">Cancelar</v-btn>
    </div>
  </form>

</template>

<script>
export default {
  nome: 'FormBasico',
  props: ['submit', 'acao', 'novo', 'editar', 'cancelar', 'salvar', 'excluir', 'id'],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      // const response = await this.submit();
      await this.submit();
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
.teste > div{
  color: white;
}
.teste:disabled > div{
  color: #b7b7b7;
}
#form{
  margin-top: 20px;
  position: relative;


  #btn-acoes-t{
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 4px;
    z-index: 1;

    .v-btn {
      margin-left: 10px;
      color: white;
      font-weight: 400;
    }
  }

  #btn-acoes-b{
    display: inline-block;
    //border-top: 1px solid gray;
    //border-left: 1px solid gray;
    border-top-left-radius: 7px;
    position: absolute;
    bottom: 0;
    right: 0;
    box-shadow: 0px 0px 5px 1px #d9d9d9;
    padding: 10px 4px;
    background-color: white;

    button{
      margin: 0px 10px;
    }

    .teste {
      color: white;
      font-weight: 400;
    }
  }
}

@media only screen and (max-width: 900px){
  #form {
    #btn-acoes-t{
      position: relative;
      text-align: right;
    }
    #btn-acoes-b {
      position: relative;
      width: 100%;
      border-radius: 0px;
      box-shadow: 0px 1px 1px 1px #d9d9d9;
      text-align: right;
    }
  }
}
</style>
